import React, { useState } from "react";
import styled from "styled-components";
import colors from "../../theme/color/ColorTheme";

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  color: #1e1e1e;
`;

const Label = styled.span`
  margin: 0 8px;
`;

const SelectWrapper = styled.div`
  position: relative;
  display: inline-block;

  select {
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    padding: 6px 28px 6px 10px;
    border: 1px solid ${colors.dash};
    border-radius: 6px;
    background-color: white;
    cursor: pointer;
    font-size: 14px;
  }

  &::after {
    content: "";
    position: absolute;
    top: 50%;
    right: 10px;
    width: 0;
    height: 0;
    pointer-events: none;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-top: 5px solid #333;
    transform: translateY(-50%);
  }
`;

function PaginationDropDown() {
  const [itemsPerPage, setItemsPerPage] = useState(10);

  return (
    <Wrapper>
      <Label>Showing</Label>
      <SelectWrapper>
        <select
          value={itemsPerPage}
          onChange={(e) => setItemsPerPage(Number(e.target.value))}
        >
          <option value={10}>10</option>
          <option value={20}>20</option>
          <option value={30}>30</option>
        </select>
      </SelectWrapper>
      <Label>Items</Label>
    </Wrapper>
  );
}

export default PaginationDropDown;
